import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import service from './api';
import md5 from './md5';
import {
    timeDown,
    changeParams,
    formatHour,
    formatTimeDate,
    isArray,
    getRandom,
    isTestEvir,
    jsBridgeForSSAI,
    isSSAI
} from './utils';
import './style.scss';
var HCISystem = {
    InitSuntory: function InitSuntory(options, cb) {
        this.isMobile = /android|ipad|iphone|ipod|android.*mobile|windows.*phone|blackberry.*mobile/i.test(window.navigator.userAgent.toLowerCase());
        this.jzjx = /JZJX_Android/i.test(navigator.userAgent);
        this.account_id = options.account_id || 0;
        this.user_id = options.user_id;
        this.isStudent = options.isStudent;
        this.course_id = options.course_id || 0;
        this.isFrom = options.isFrom ? options.isFrom : '';
        this.timer = null;
        this.initStatus = false;
        this.limit_type = 0;
        if (this.jzjx) {
            return;
        }
        this.getStopEle();
        this.getToastEle();
        this.getAjaxData();
        window.setTimeCb = function (res) {
        };
        var that = this;
        if (this.isMobile) {
            document.addEventListener('visibilitychange', function () {
                !document.hidden && that.getAjaxData();
            });
        }
    }
};
HCISystem.InitSuntory.prototype = {
    getAjaxData: function getAjaxData() {
        var _this = this;
        return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
            var res, beginTime, endTime, begin, end, openTime, todayTime;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return _this.ajaxPost();
                    case 3:
                        res = _context.sent;
                        _context.next = 9;
                        break;
                    case 6:
                        _context.prev = 6;
                        _context.t0 = _context['catch'](0);
                        console.log(_context.t0);
                    case 9:
                        if (res && res.code == 200 && res.data && !isArray(res.data)) {
                            beginTime = res.data.begin_time || 0;
                            endTime = res.data.end_time || 0;
                            begin = res.data.begin || 0;
                            end = res.data.end || 0;
                            openTime = ''.concat(begin, ' - ').concat(end);
                            document.getElementById('hciOpenTime').innerText = openTime;
                            if (!isSSAI()) {
                                todayTime = localStorage.getItem('todayTime');
                                _this.showDataAction(res, todayTime);
                            } else {
                                jsBridgeForSSAI('getData', { key: 'accountId_'.concat(_this.account_id) }, 'getTimeCb');
                                window.getTimeCb = function (resList) {
                                    console.log(resList, 'resList---');
                                    var resObj = JSON.parse(resList);
                                    console.log(resObj.data, 'resObj----');
                                    var todayTime = '';
                                    if (resObj.code == 0 && resObj.data['accountId_'.concat(_this.account_id)]) {
                                        todayTime = resObj.data['accountId_'.concat(_this.account_id)];
                                    }
                                    _this.showDataAction(res, todayTime);
                                };
                            }
                        }
                    case 10:
                    case 'end':
                        return _context.stop();
                    }
                }
            }, _callee, null, [[
                    0,
                    6
                ]]);
        }))();
    },
    showDataAction: function showDataAction(res, todyTime) {
        var _this2 = this;
        var curPursTime = 10;
        var curToadyTime = formatTimeDate() + this.account_id;
        var differTime = res.data.remain_time;
        var frequency = res.data.frequency;
        var beginTime = res.data.begin_time || 0;
        var endTime = res.data.end_time || 0;
        var curTime = res.data.cur_time;
        var begin = res.data.begin || 0;
        var end = res.data.end || 0;
        var limit_type = res.data.limit_type;
        var isStudent = this.isStudent;
        var configList = res.data.config_list;
        var list = configList.find(function (option) {
            return option.remain_time == differTime;
        });
        var dataList = {
            beginTime: beginTime,
            endTime: endTime,
            differTime: differTime,
            curTime: curTime,
            begin: begin,
            end: end
        };
        var configData = {
            allow_close: differTime > 300,
            differTime: differTime,
            isToast: differTime <= 300 || differTime == 1800 || differTime == 600 || todyTime != curToadyTime
        };
        console.log(configData, 56);
        if (!res.data.remain_time) {
            if (limit_type === 1) {
                this.openPopPage();
            } else if (limit_type === 2) {
                this.getLimitEle();
            } else {
                if (this.isFrom === 'studentCenter')
                    return;
                window.location.replace(res.data.redirect_url);
            }
            return;
        }
        if (differTime > 3600) {
            setTimeout(function () {
                _this2.getAjaxData();
            }, frequency * 1000);
            if (limit_type === 1) {
                res.data.remain_time && this.getToastMsgAction(dataList, list, {}, isStudent, todyTime);
            }
        } else {
            var surplusTime = differTime;
            var startTimeAction = function startTimeAction(surplusTime) {
                _this2.startTimer = setInterval(function () {
                    surplusTime--;
                    var configData = {
                        allow_close: surplusTime > 300,
                        differTime: differTime,
                        isToast: surplusTime <= 300 || surplusTime == 1800 || surplusTime == 600 || todyTime != curToadyTime
                    };
                    differTime = configData.isToast ? surplusTime : differTime;
                    if (surplusTime <= 300) {
                        clearInterval(_this2.startTimer);
                        _this2.startTimer = null;
                        configData.differTime = surplusTime;
                        dataList.differTime = surplusTime;
                        _this2.getToastMsgAction(dataList, list, configData, '', todyTime);
                        return;
                    }
                    if (surplusTime == 600 || surplusTime == 1800) {
                        clearInterval(_this2.startTimer);
                        _this2.startTimer = null;
                        configData.differTime = surplusTime;
                        dataList.differTime = surplusTime;
                        _this2.getToastMsgAction(dataList, list, configData, '', todyTime);
                        setTimeout(function () {
                            configData.differTime = surplusTime - 10;
                            dataList.differTime = surplusTime - 10;
                            startTimeAction(surplusTime - 10);
                        }, curPursTime * 1000);
                    }
                }, 1000);
            };
            console.log(todyTime, curToadyTime, surplusTime);
            if (todyTime == curToadyTime && surplusTime > 300) {
                console.log('come---');
                startTimeAction(surplusTime);
            } else if (todyTime == curToadyTime && surplusTime <= 300 && surplusTime != 0) {
                this.getToastMsgAction(dataList, list, configData, '', todyTime);
            } else {
                var _isStudent = surplusTime <= 300 ? false : this.isStudent;
                console.log(_isStudent, 118);
                if (this.isStudent) {
                    this.getToastMsgAction(dataList, list, configData, _isStudent, todyTime);
                    setTimeout(function () {
                        startTimeAction(surplusTime - 10);
                    }, (curPursTime - 1) * 1000);
                } else {
                    startTimeAction(surplusTime);
                }
            }
        }
    },
    getStopEle: function getStopEle() {
        var pop = document.createElement('div');
        pop.classList = 'stop-study-page-fixed';
        var str = '';
        var html = '<div class="hci-moon"><img src="//statics.classba.cn/prod/fe_public/public/stopSystem/img/moon.png" /></div><div class="hci-content"><div class="hci-head">非学习时段\uFF0C系统停止开放</div><div class="hci-body"><p>亲爱的同学\uFF0C</p><p>夜深人静\uFF0C已经很晚啦\uFF01</p><p>劳逸结合很重要哦\uFF01请在学习时段内来吧~</p><div class="active-time">系统开放学习时段\uFF1A<span id="hciOpenTime">6:00 - 21:00</span></div></div></div>';
        str = !this.isMobile ? '<div class="stop-study-frame">'.concat(html, '</div>') : html;
        pop.innerHTML = str;
        document.body.appendChild(pop);
    },
    getToastEle: function getToastEle() {
        var toast = document.createElement('div');
        toast.className = 'hci-stop-toast-fixed';
        var ele = '';
        ele = '<span class="hci-close-btn" id="hCloseBtn"></span><div class="hci-stop-toast-body" id="toastBody"></div>';
        toast.innerHTML = ele;
        document.body.appendChild(toast);
    },
    getToastMsgAction: function getToastMsgAction(data, list, configData, isNormal, todyTime) {
        var ele = '';
        var countdown = list;
        var beginTime = data.beginTime, endTime = data.endTime, curTime = data.curTime, differTime = data.differTime, begin = data.begin, end = data.end;
        var openTime = ''.concat(begin, ' - ').concat(end);
        var allow_close = 1;
        var diffTime = configData.differTime;
        console.log(differTime, 'differTime');
        var curToadyTime = formatTimeDate() + this.account_id;
        var onSwitchClicked = function onSwitchClicked(e) {
            var target = e.target;
            if (target.classList.contains('hc-icon-up')) {
                target.classList.remove('hc-icon-up');
                target.classList.add('hc-icon-down');
                document.querySelector('.hc-extra-info').style.display = 'none';
            } else {
                target.classList.remove('hc-icon-down');
                target.classList.add('hc-icon-up');
                document.querySelector('.hc-extra-info').style.display = 'block';
            }
        };
        isNormal = isNormal ? true : false;
        if (!this.isMobile) {
            console.log(isNormal, configData.isToast && differTime && todyTime != curToadyTime, 160);
            console.log(!isNormal, configData.isToast, differTime, 189);
            if (isNormal) {
                ele = '<p>亲爱的同学\uFF0C系统开放学习时段为\uFF1A\u201C'.concat(openTime, '\uFF0C\u201D</p><p>非学习时段系统将强制下线请合理安排时间哦~</p><p><span class="bold" id="hcountTime">10s</span>后自动关闭弹窗</p>');
                this.initStatus = true;
            } else if (!isNormal && configData.isToast && differTime) {
                console.log('elt---', 198);
                allow_close = configData.allow_close;
                var remain_time = configData.differTime;
                remain_time = parseInt(remain_time / 60);
                this.initStatus = true;
                console.log(remain_time, 'remain_time---');
                ele = ''.concat(!allow_close ? '<a href="javascript:void(0)" class="hc-switch-btn hc-icon-up"></a>' : '', '').concat(!allow_close ? '<p>系统关闭倒计时\uFF1A<span class="bold" id="hTimeDown">'.concat(timeDown(diffTime), '</span></p>') : '', '<p class="hc-extra-info">亲爱的同学\uFF0C系统将于').concat(!allow_close ? formatHour(endTime) : ''.concat(remain_time, '分钟后'), '关闭\uFF01劳逸结合很重要哦\uFF01请在学习时段内来吧~<br/>系统开放学习时段\uFF1A').concat(openTime, '</p>').concat(allow_close ? '<p><span class="bold" id="hcountTime">10s</span>后自动关闭弹窗</p>' : '', '');
            }
        } else {
            if (isNormal) {
                ele = '<p>亲爱的同学\uFF0C系统开放学习时段\uFF1A'.concat(openTime, '\uFF0C</p><p>非学习时段系统将强制下线请合理安排时间哦~</p><p><span class="bold" id="hcountTime">10s</span>后自动关闭弹窗</p>');
                this.initStatus = true;
            } else if (!isNormal && configData.isToast && differTime) {
                var _remain_time = configData.differTime;
                allow_close = configData.allow_close;
                _remain_time = parseInt(_remain_time / 60);
                this.initStatus = true;
                ele = ''.concat(!allow_close ? '<a href="javascript:void(0)" class="hc-switch-btn hc-icon-up"></a>' : '', '').concat(!allow_close ? '<p>系统关闭倒计时\uFF1A<span class="bold" id="hTimeDown">'.concat(timeDown(diffTime), '</span></p>') : '', '').concat(allow_close ? '<p>亲爱的同学\uFF0C系统将于'.concat(_remain_time, '分钟关闭\uFF01</p>') : '', '<p class="hc-extra-info">劳逸结合很重要哦\uFF01请在学习时段内来吧~<br/>系统开放学习时段\uFF1A').concat(openTime, '</p>').concat(allow_close ? '<p><span class="bold" id="hcountTime">10s</span>后自动关闭弹窗</p>' : '', '');
            }
        }
        var toastEle = document.getElementById('toastBody');
        var toastCosEle = document.querySelector('.hci-stop-toast-fixed');
        toastEle.innerHTML = ele;
        document.querySelector('.hc-switch-btn') && document.querySelector('.hc-switch-btn').addEventListener('click', onSwitchClicked, false);
        console.log(this.initStatus, !countdown, differTime, 206);
        if (isNormal && differTime && todyTime != curToadyTime || configData.isToast) {
            toastCosEle.style.display = 'block';
            this.timeAction(allow_close, configData.isToast, differTime);
            this.initStatus = false;
            if (isSSAI()) {
                jsBridgeForSSAI('setData', {
                    key: 'accountId_'.concat(this.account_id),
                    value: formatTimeDate() + this.account_id
                }, 'setTimeCb');
            } else {
                localStorage.setItem('todayTime', curToadyTime);
            }
        }
    },
    ajaxPost: function ajaxPost() {
        var timestamp = new Date().getTime();
        var data1 = {
            account_id: this.account_id,
            course_id: this.course_id,
            rand: getRandom(6),
            timestamp: timestamp,
            user_id: this.user_id
        };
        var param = changeParams(data1);
        console.log('原始参数:', param);
        var secretKey = isTestEvir() ? 'zbwe7U8lVhDVgXSI2uSFjPOT7XPNm19K' : 'RrA3N3Qytd7mV8nQ6kxIWo2NSRMf5TSF';
        param += secretKey;
        param = md5(param);
        console.log('加密param', param);
        var newObj = Object.assign(data1, { sign: param });
        var data = { data: newObj };
        var url = isTestEvir() ? '//m.test.songshuai.com' : '//m.songshuai.com';
        return service.request({
            baseURL: ''.concat(url, '/api/userSupervision/checkLimitLearn'),
            method: 'post',
            data: data
        });
    },
    closeToastAction: function closeToastAction() {
        var toastCosEle = document.querySelector('.hci-stop-toast-fixed');
        this.timer && clearInterval(this.timer);
        this.timer = null;
        toastCosEle.style.display = 'none';
    },
    timeAction: function timeAction(allow_close, isToast, diffTime) {
        var _this3 = this;
        var curTime = 10;
        var timeEle = document.getElementById('hcountTime');
        var timedownEle = document.getElementById('hTimeDown');
        var that = this;
        var closeBtn = document.querySelector('.hci-close-btn');
        console.log(allow_close, isToast, 'isToast----');
        if (allow_close) {
            if (closeBtn) {
                closeBtn.style.display = 'block';
                closeBtn.addEventListener('click', function () {
                    that.closeToastAction();
                });
            }
            this.timer = setInterval(function () {
                curTime--;
                console.log(curTime, 'curTime---');
                curTime == 0 && _this3.closeToastAction();
                if (timeEle)
                    timeEle.innerText = ''.concat(curTime, 's');
            }, 1000);
        }
        if (!allow_close) {
            diffTime = parseInt(diffTime);
            console.log(diffTime, 274);
            closeBtn.style.display = 'none';
            var timeDer = setInterval(function () {
                timedownEle.innerHTML = timeDown(diffTime);
                diffTime--;
                if (diffTime <= 0) {
                    clearInterval(timeDer);
                    diffTime = 0;
                    _this3.closeToastAction();
                    _this3.openPopPage();
                }
            }, 1000);
        }
    },
    openPopPage: function openPopPage() {
        var popEle = document.querySelector('.stop-study-page-fixed');
        popEle.style.display = 'block';
    },
    getLimitEle: function getLimitEle() {
        var dom = document.createElement('div');
        dom.classList = 'isLimited';
        var str = '<div class="cont">' + '<div class="header">' + '<div class="icon"></div>' + '<span>当前系统已停止学习服务</span>' + '</div>' + '<div class="body">' + '<div class="desc">' + '<dl>' + '<dt>亲爱的同学\uFF0C你好\uFF1A</dt>' + '<dd>系统当前检测到\uFF0C你可能违反了国家双减政策或教育局的规定\uFF0C系统已停止提供学习服务\uFF0C请合理安排学习时间\u3002</dd>' + '<dd>松鼠Ai将全力响应国家双减政策\uFF0C响应当地教育局规定\u3002</dd>' + '</dl>' + '</div>' + '<div class="icon-bottom"></div>' + '</div>';
        '</div>';
        if (this.isMobile) {
            dom.classList = 'isLimited isIphone';
        }
        dom.innerHTML = str;
        document.body.appendChild(dom);
    }
};
export default HCISystem;